/* @flow */
import React from 'react';

import AuthActions from 'auth/AuthActions';
import AuthenticationView from 'auth/components/AuthenticationView.jsx';
import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import Copy from 'components/Copy.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import LinkSmsVerificationCodeBox from 'user/components/LinkSmsVerificationCodeBox.jsx';
import TitleHeader from 'components/TitleHeader.jsx';
import ToastActions from 'actions/ToastActions';

import './styles/ForgotPasswordPage.scss';

class ForgotPasswordPage extends React.Component {
  props: {
    location: Object,
    router: Object,
  };

  state = {
    medium: '',
    phoneNumber: '',
    verificationToken: '',
    requestSubmitted: false,
  };

  onUidChange = (event: Object) => {
    const value = event.target.value;
    const medium = value.includes('@') ? 'email' : 'sms';
    this.setState({ medium });
  }

  onSmsCodeConfirmed = (response: {token: string}) => {
    AuthActions.accessTokenSignIn(response.token).then(() => {
      this.props.router.push('/reset_password/');
    }).catch(e => console.error('Sign in failed', e));
  }

  onResend = () => {
    this.handleSubmit({ uid: this.state.phoneNumber });
  }

  handleSubmit = (data: {uid: string}) => {
    const { uid } = data;
    const onSuccess = (response) => {
      this.setState({
        phoneNumber: uid,
        verificationToken: response.token,
        requestSubmitted: true,
      });
    };

    const onError = (error) => ToastActions.showAPIError(error);

    AuthActions
      .requestPasswordReset(uid)
      .then(onSuccess)
      .catch(onError);
  }

  renderVerificationToken() {
    return (
      <LinkSmsVerificationCodeBox
        token={this.state.verificationToken}
        phoneNumber={this.state.phoneNumber}
        onDone={this.onSmsCodeConfirmed}
        onResend={this.onResend}
        successMessage={'Correct!'}
      />
    );
  }

  renderSent() {
    const subtext = this.state.verificationToken ? 'Please check your phone for your reset code.' : null;

    return (
      <div>
        <TitleHeader
          image={require('assets/images/email-sent.svg')}
          imageClassName="ForgotPasswordPage-title-image"
          title="Email sent"
          subtext={subtext}
        />
        {
          !this.state.verificationToken &&
            <Copy center>
              <p>
                Please check your email for instructions on how to reset your password! If you do not receive anything, please check your spam folder for an email from remind.com.
              </p>
              <p>
                <Link href={LinkConstants.FORGOT_PASSWORD} target="_blank">Click here</Link>
                {' '}
                if you need further assistance.
              </p>
            </Copy>
        }
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <FormInput
            label="Email address or phone number"
            name="uid"
            autoComplete="username"
            placeholder="Email address or phone number"
            onChange={this.onUidChange}
            size="large"
            value={this.props.location.query.email || ''}
            showErrorAfterBlur
            required
            validations={
              this.state.medium === 'email' ?
                { isEmail: true } :
                { couldPlausiblyBeANorthAmericanPhoneNumber: true }
            }
            validationErrors={{
              isEmail: 'Invalid email. Please try again.',
              couldPlausiblyBeANorthAmericanPhoneNumber:
              'Invalid phone number or email address. Please try again.',
            }}
          />
          <Buttons axis="y">
            <Button
              type="submit"
              className="ForgotPassword-submit"
              level="primary"
              full
              eventElementName="ForgotPassword-submit">
              Send reset instructions
            </Button>
            <Button
              href={LinkConstants.FORGOT_PASSWORD}
              target="_blank"
              color="brand"
              level="text"
              data-test="help-button">
              Help
            </Button>
          </Buttons>
        </Form>
      </div>
    );
  }

  render() {
    if (this.state.verificationToken) {
      return this.renderVerificationToken();
    }

    return (
      <AuthenticationView {...this.props} title="Forgot password?">
        {this.state.requestSubmitted ? this.renderSent() : this.renderForm()}
      </AuthenticationView>
    );
  }
}

export default ForgotPasswordPage;



// WEBPACK FOOTER //
// ./src/auth/components/ForgotPasswordPage.jsx